import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

// --- (Tus importaciones de imágenes se mantienen exactamente igual) ---
import dona1slider1 from "../assets/dona1slider1.webp"
import dona1slider2 from "../assets/dona1slider2.webp"
import dona1slider3 from "../assets/dona1slider3.webp"
import dona1slider4 from "../assets/dona1slider4.webp"
import dona2slider1 from "../assets/dona2slider1.webp"
import dona2slider2 from "../assets/dona2slider2.webp"
import dona2slider3 from "../assets/dona2slider3.webp"
import dona2slider4 from "../assets/dona2slider4.webp"
import dona2slider5 from "../assets/dona2slider5.webp"
import dona2slider6 from "../assets/dona2slider6.webp"
import dona2slider7 from "../assets/dona2slider7.webp"
import dona2slider8 from "../assets/dona2slider8.webp"
import dona2slider9 from "../assets/dona2slider9.webp"
import dona2slider10 from "../assets/dona2slider10.webp"
import dona2slider11 from "../assets/dona2slider11.webp"
import dona3slider1 from "../assets/dona3slider1.webp"
import dona3slider2 from "../assets/dona3slider2.webp"
import dona3slider3 from "../assets/dona3slider3.webp"
import dona3slider4 from "../assets/dona3slider4.webp"
import dona3slider5 from "../assets/dona3slider5.webp"
import dona3slider6 from "../assets/dona3slider6.webp"
import dona3slider7 from "../assets/dona3slider7.webp"
import dona3slider8 from "../assets/dona3slider8.webp"
import dona3slider9 from "../assets/dona3slider9.webp"
import dona3slider10 from "../assets/dona3slider10.webp"
import dona4slider1 from "../assets/dona4slider1.webp"
import dona4slider2 from "../assets/dona4slider2.webp"
import dona4slider3 from "../assets/dona4slider3.webp"
import dona4slider4 from "../assets/dona4slider4.webp"
import dona4slider5 from "../assets/dona4slider5.webp"
import dona5slider1 from "../assets/dona5slider1.webp"
import dona6slider1 from "../assets/dona6slider1.webp"
import dona6slider2 from "../assets/dona6slider2.webp"
import dona6slider3 from "../assets/dona6slider3.webp"
import dona6slider4 from "../assets/dona6slider4.webp"
import dona6slider5 from "../assets/dona6slider5.webp"
import dona6slider6 from "../assets/dona6slider6.webp"
import dona7slider1 from "../assets/dona7slider1.webp"
import dona8slider1 from "../assets/dona8slider1.webp"
import dona8slider2 from "../assets/dona8slider2.webp"
import dona8slider3 from "../assets/dona8slider3.webp"
import dona8slider4 from "../assets/dona8slider4.webp"
import dona8slider5 from "../assets/dona8slider5.webp"
import dona8slider6 from "../assets/dona8slider6.webp"
import dona9slider1 from "../assets/dona9slider1.webp"
import dona10slider1 from "../assets/dona10slider1.webp"
import dona10slider2 from "../assets/dona10slider2.webp"
import dona10slider3 from "../assets/dona10slider3.webp"
import dona10slider4 from "../assets/dona10slider4.webp"
import dona10slider5 from "../assets/dona10slider5.webp"
import dona10slider6 from "../assets/dona10slider6.webp"
import dona10slider7 from "../assets/dona10slider7.webp"
import dona11slider1 from "../assets/dona11slider1.webp"
import dona11slider2 from "../assets/dona11slider2.webp"
import dona11slider3 from "../assets/dona11slider3.webp"
import dona11slider4 from "../assets/dona11slider4.webp"
import dona11slider5 from "../assets/dona11slider5.webp"

import dona12slider1 from "../assets/dona12slider1.webp"
import dona12slider2 from "../assets/dona12slider2.webp"
import dona12slider3 from "../assets/dona12slider3.webp"
import dona12slider4 from "../assets/dona12slider4.webp"
import dona12slider5 from "../assets/dona12slider5.webp"
import dona12slider6 from "../assets/dona12slider6.webp"
import dona12slider7 from "../assets/dona12slider7.webp"
import dona12slider8 from "../assets/dona12slider8.webp"
import dona12slider9 from "../assets/dona12slider9.webp"
import dona12slider10 from "../assets/dona12slider10.webp"
import dona12slider11 from "../assets/dona12slider11.webp"
import dona12slider12 from "../assets/dona12slider12.webp"
import dona12slider13 from "../assets/dona12slider13.webp"

import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";

const Donaciones = () => {

  // Estilo común para normalizar las imágenes de los carruseles
  const imgStyle = "h-[300px] md:h-[400px] object-cover rounded-xl";

  const ItemActividad = ({ titulo, texto, imagenes, reverse }) => (
    <div className='w-[95%] bg-white py-12 px-6 shadow-xl rounded-3xl mb-12 mx-auto border border-gray-100 hover:shadow-2xl transition-shadow duration-300'>
      <div className={`max-w-[1240px] mx-auto grid md:grid-cols-2 gap-10 items-center ${reverse ? 'md:flex-row-reverse' : ''}`}>
        
        <div className={`${reverse ? 'md:order-2' : ''}`}>
          {imagenes.length > 1 ? (
            <Carousel 
                showStatus={false} 
                showThumbs={false} 
                infiniteLoop={true} 
                autoPlay={true}
                className='overflow-hidden rounded-2xl shadow-lg'
            >
              {imagenes.map((img, index) => (
                <div key={index}>
                  <img src={img} className={imgStyle} alt={titulo} />
                </div>
              ))}
            </Carousel>
          ) : (
            <img src={imagenes[0]} className={`${imgStyle} w-full shadow-lg`} alt={titulo} />
          )}
        </div>

        <div className={`flex flex-col justify-center space-y-4 ${reverse ? 'md:order-1' : ''}`}>
          <h2 className='text-2xl md:text-4xl font-extrabold text-slate-800 border-b-4 border-blue-600 w-fit pb-2'>
            {titulo}
          </h2>
          <p className='text-gray-600 text-lg leading-relaxed text-justify'>
            {texto}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-gray-50">
      <ScrollToTop />
      <Navbar />
      
      <div className="pt-24 pb-12">
        <h1 className="text-4xl md:text-6xl text-center font-black mb-16 text-blue-900 tracking-tight">
          • Donaciones y Actividades •
        </h1>

        <ItemActividad 
          titulo="Ayuda Humanitaria en Córdoba"
          texto="Fundadocentes JDD en solidaridad con las comunidades de Cordoba ante los desastres naturales sucedidos en las últimas semanas, hace entregas de alimentos y elementos para atender las primeras necesidades de las múltiples familias damnificadas"
          imagenes={[dona12slider2,dona12slider6,dona12slider7,dona12slider8,dona12slider9,dona12slider10,dona12slider11,dona12slider12,dona12slider13,dona12slider1,dona12slider3,dona12slider4,dona12slider5]}
        />

        <ItemActividad 
          titulo="Actividad en Sitio Nuevo"
          texto="Labor con niños creando espacios de cuidado y atención a niños de Sitionuevo Magdalena."
          imagenes={[dona11slider1, dona11slider2, dona11slider3, dona11slider4, dona11slider5]}
        />

        <ItemActividad 
          reverse
          titulo="Donación computadores"
          texto="En el Centro Educativo El Divino Niño ubicado en el municipio de Sitio Nuevo, Magdalena se realiza una donación de equipos de computación para el acondicionamiento de una sala de informática."
          imagenes={[dona1slider1, dona1slider2, dona1slider3, dona1slider4]}
        />

        <ItemActividad 
          titulo="Donación útiles escolares"
          texto="El día sábado 23 de Marzo de 2024 se desarrolló la jornada educativa en la Biblioteca el Oasis del Barrio La Sierrita de Barranquilla donde a 38 niños y niñas se les acompañó en sus jornadas de formación, programadas por su directora Nubia Huertas y su equipo de apoyo, así mismo se entregaron útiles escolares y elementos educativos para apoyar el proceso sobresaliente que se está realizando en beneficio de muchos niños de la comunidad del Barrio La Sierrita."
          imagenes={[dona10slider1, dona10slider2, dona10slider3, dona10slider4, dona10slider5, dona10slider6, dona10slider7]}
        />

        <ItemActividad 
          reverse
          titulo="Donaciones a comunidades vulnerables"
          texto="Se entregaron mercados a familias en estado vulnerable afectadas por la pandemia Covid 19, que perdieron sus trabajos. Estas familias fueron del casco urbano y sector rural de Sitionuevo departamento del Magdalena."
          imagenes={[dona2slider1, dona2slider2, dona2slider3, dona2slider4, dona2slider5, dona2slider6, dona2slider7, dona2slider8, dona2slider9, dona2slider10, dona2slider11]}
        />

        <ItemActividad 
          titulo="Charlas educativas"
          texto="Se realiza charla sobre bullying con los padres de familia pertenecientes a la comunidad educativa del Centro Educativo El Divino Niño ubicado en el municipio de Sitio Nuevo, Magdalena."
          imagenes={[dona3slider1, dona3slider2, dona3slider3, dona3slider4, dona3slider5, dona3slider6, dona3slider7, dona3slider8, dona3slider9, dona3slider10]}
        />

        <ItemActividad 
          reverse
          titulo="Charla García Marquez en la Mojana"
          texto="En la charla de García Marquez en La Mojana, se hace un recuento de la presencia de esta región y su historia en la obra del Premio Nobel. Fue realizada por el docente Manuel Isidro Alvarez, autor del libro sobre las aguas y gran conocedor de la obra de Gabriel García Marquez."
          imagenes={[dona4slider1, dona4slider2, dona4slider3, dona4slider4, dona4slider5]}
        />

        <ItemActividad 
          titulo="Entrega de Libros"
          texto="El 25 de febrero de 2023 se efectuo jornada de entrega de utililes escolares a niños del municipio de Stionuevo y Sector de la Puente en el Departameto del Magadalena."
          imagenes={[dona8slider1, dona8slider2, dona8slider3, dona8slider4, dona8slider5, dona8slider6]}
        />

        <ItemActividad 
          reverse
          titulo="Entrega de libros"
          texto="Realizamos entrega de útiles escolares a la comunidad de Sitionuevo Magdalena, apoyando la labor liderada por el Alcalde de este municipio ribereño del departamento del Magdalena, con la ayuda de Efraín Sánchez Jr, Juan De la Cruz y Rodolfo Fonseca."
          imagenes={[dona5slider1]}
        />

        <ItemActividad 
          titulo="Jornada de salud"
          texto="Jornada de Salud Infantil en el corregimiento El Corral de San Luis Municipio de Tubara Atlántico desarrollada el 27 de agosto de 2022, donde con éxito y al apoyo de Procaps Coomonomeros, otras personas benefactores y funcionarios de Sura Monomeros y Fundadocente JDD quienes a titulo personal se unieron a la campaña de salud donde se atendieron en medicina infantil mas de 90 niños, en psicología infantil y de familia mas de 15 niños, y 20 adultos en medina general. Labor cumplida con éxito de la mano de un gran grupo de personas de la comunidad y de profesionales de la salud."
          imagenes={[dona6slider1, dona6slider2, dona6slider3, dona6slider4, dona6slider5, dona6slider6]}
        />

        <ItemActividad 
          reverse
          titulo="Entrega de computador"
          texto="Entrega de computador a estudiantes del colegio de Stionuevo Magdalena - 5 de Agosto de 2023."
          imagenes={[dona9slider1]}
        />

        <ItemActividad 
          titulo="Acompañamiento a vendedores ambulantes"
          texto="Charla y apoyo a vendedores ambulantes con chalecos de trabajo, actividad desarrollada en el barrio Don Jaca Santa Marta."
          imagenes={[dona7slider1]}
        />

      </div>
      <Footer />
    </div>
  );
};

export default Donaciones;